// https://en.wikipedia.org/wiki/Binary_prefix
function bytesToSize(bytes: number, decimal = false): string {
  if (bytes < 1024) {
    return `${bytes}B`;
  }

  const kilobytes = Math.round(bytes / (decimal ? 1000 : 1024));

  if (kilobytes > 1024) {
    return `${(kilobytes / 1024).toFixed(2)}MB`;
  }

  return `${kilobytes}kB`;
}

export default bytesToSize;
